import { useSession } from "@src/appV2/Auth/api/useSession";
import constate from "constate";
import { hasAnyTrueValue } from "./utils";

export interface WorkerMenuPrivileges {
  dashboard?: boolean;
  chat?: boolean;
  dnr?: boolean;
  payrollSection?: {
    payroll: boolean;
    stripeTransfers: boolean;
    stripePayouts: boolean;
  };
  clipboardScore?: boolean;
  placementSection?: { candidateProfile: boolean; exclusions: boolean; documents: boolean };
  homeHealthSection?: { cases: boolean; visits: boolean };
}

export function useGetWorkerMenuPrivileges(): WorkerMenuPrivileges {
  const { type, admin } = useSession();

  const isWorker = type === "AGENT";
  if (!isWorker) {
    return {};
  }

  const dashboard = true;

  const chat = true;

  const dnr = true;

  const payroll = true;
  const stripeTransfers = true;
  const stripePayouts = true;
  const payrollSection = { payroll, stripeTransfers, stripePayouts };

  const clipboardScore = true;

  const candidateProfile = true;
  const exclusions = true;
  const documents = true;
  const placementSection = { candidateProfile, exclusions, documents };

  const homeHealthSection = admin ? { cases: true, visits: true } : undefined;

  return {
    dashboard,
    chat,
    dnr,
    payrollSection: hasAnyTrueValue(payrollSection) ? payrollSection : undefined,
    clipboardScore,
    placementSection: hasAnyTrueValue(placementSection) ? placementSection : undefined,
    homeHealthSection,
  };
}

export const [WorkerMenuPrivilegesProvider, useWorkerMenuPrivilegesProviderContext] = constate(
  useGetWorkerMenuPrivileges
);
